import { useTranslation } from 'next-i18next/pages';

import {
  INQUIRY_INTEREST_VALUES,
  inquiryInterestLabelKey,
} from './inquiryInterest';

/**
 * ### useInquiryFormOptions
 *
 * Provides the translated option lists of every select in the inquiry form.
 * Interest options carry the InquiryInterest machine key as their value; the other lists keep
 * the value that is persisted with the inquiry.
 *
 * @returns Option lists keyed by the select they belong to
 */
export default function useInquiryFormOptions() {
  const { t } = useTranslation('common');

  return {
    employeesOptions: [
      { value: '1-10명', label: t('1-10명') },
      { value: '10-100명', label: t('10-100명') },
      { value: '100-1000명', label: t('100-1000명') },
      { value: '1000명 이상', label: t('1000명 이상') },
    ],
    interestOptions: INQUIRY_INTEREST_VALUES.map((interest) => ({
      value: interest,
      label: t(inquiryInterestLabelKey(interest)),
    })),
    inquirySourceOptions: [
      {
        value: 'ai_answer',
        label: t('AI 검색·답변 (ChatGPT, Gemini, Perplexity, Claude 등)'),
      },
      {
        value: 'search_engine',
        label: t('검색엔진 (Google, Naver, Bing 등)'),
      },
      { value: 'partner_referral', label: t('고객사·파트너 소개') },
      { value: 'event', label: t('전시회·세미나') },
      { value: 'content_social', label: t('기사·블로그·SNS') },
      { value: 'other', label: t('기타') },
    ],
    aiServiceOptions: [
      { value: 'chatgpt', label: 'ChatGPT' },
      { value: 'gemini', label: 'Gemini' },
      { value: 'perplexity', label: 'Perplexity' },
      { value: 'claude', label: 'Claude' },
      { value: 'microsoft_copilot', label: 'Microsoft Copilot' },
      { value: 'other', label: t('기타') },
      { value: 'unknown', label: t('기억나지 않음') },
    ],
  };
}
